import { Toaster as HotToaster, ToastBar, toast } from 'react-hot-toast'
import { IconButton } from '@mui/material'
import {
  DefaultBox,
  SuccessBox,
  ErrorBox,
  Message,
  SuccessIcon,
  ErrorIcon,
  StyledCloseIcon,
  CloseButton,
} from './Toast.styles'
import { ToastProps } from './Toast.types'

export const Toaster = ({ options }: ToastProps) => {
  return (
    <HotToaster
      toastOptions={{
        duration: 5000,
        position: 'bottom-left',
        success: {
          duration: 5000,
          position: 'bottom-left',
        },
        error: {
          duration: Infinity,
          position: 'bottom-left',
        },
        ...options,
      }}
    >
      {(t) => (
        <ToastBar toast={t} style={{ maxWidth: '420px', minHeight: '64px' }}>
          {({ icon, message }) => {
            let WrapperBox = DefaultBox
            let IconComponent = icon

            if (t.type === 'success') {
              WrapperBox = SuccessBox
              IconComponent = <SuccessIcon />
            } else if (t.type === 'error') {
              WrapperBox = ErrorBox
              IconComponent = <ErrorIcon />
            }

            return (
              <WrapperBox display="flex" alignItems="center" padding="8px 16px">
                {IconComponent}
                <Message>{message}</Message>
                {t.type !== 'loading' && (
                  <IconButton
                    onClick={() => toast.dismiss(t.id)}
                    size="small"
                    sx={{ padding: 0, marginLeft: 'auto' }}
                  >
                    <StyledCloseIcon />
                  </IconButton>
                )}
              </WrapperBox>
            )
          }}
        </ToastBar>
      )}
    </HotToaster>
  )
}
